import LinearProgress from '@mui/material/LinearProgress';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import React from 'react';
import DashboardPage from '../../components/Dashboard/DashboardPage';
import withApollo from '../../lib/withApollo';

const Publish = dynamic(() => import('../../components/Dashboard/Publish'), {
  loading: () => <LinearProgress color="primary" />,
  ssr: false,
});

const PublishPage = () => {
  const router = useRouter();

  const {
    permlink,
    draftId,
    clone,
    community,
    youtubeId,
    open,
    longitude,
    latitude,
  } = router.query;

  return (
    <DashboardPage
      open={open}
      bottomNav={1}
      includeMapbox
      label="publish"
      content={
        <Publish
          youtubeId={youtubeId}
          permlink={permlink}
          draftId={draftId}
          clone={clone}
          community={community}
          initialLocation={{ longitude, latitude }}
        />
      }
    />
  );
};

export default withApollo(PublishPage);
